/****************************************************************************************************
* utill.js: Helper Functions
****************************************************************************************************/

const DEBUG = true;

////////////////////////////// Wrapping console.log
function csLog(...msg){
  if(DEBUG === false) return;

  // let arg = '';
  // for(let i = 0; i < arguments.length; i++) arg += arguments[i] + ' ';
  // if(typeof console != "undefined") console.log(arg.substring(0, arg.length-1));

  if(typeof console != "undefined") console.log(...msg);
}


////////////////////////////// Get a random sign
function randomSign() {
  return (Math.random() < 0.5)? 1 : -1;
}


////////////////////////////// Get a random number between min and max
// min: included
// max: excluded
function random(min, max) {
  if (max == null) { max = min; min = 0; }
  return Math.random() * (max - min) + min;
}


////////////////////////////// Get a random intiger number between min and max
// min: included, the next integer greater than min if min isn't an integer
// max: excluded
function randomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max-min) + min);
}


////////////////////////////// Get a random intiger number between min and max
// min: included, the next integer greater than min if min isn't an integer
// max: included, the prev integer smaller than max if max isn't an integer
function randomIntIncMax(min, max){
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min);
}


////////////////////////////// Get a round number with a base
function round (base, num) { return Math.round(num / base) * base; }


////////////////////////////// Get a function using a base to get round number
function roundFn (base) { return (num) => Math.round(num / base) * base; }


////////////////////////////// Get a round number with a base 10
const round10 = roundFn(10);


////////////////////////////// Format number with decimal place
const decimalPlace = (num, place = 2) => {
  let temp = 1;
  for(let i = 0; i < place; i++) temp *= 10;
  return Math.round(num * temp) / temp
}


////////////////////////////// Delay, Sleep, Pause, & Wait in JavaScript
// https://www.sitepoint.com/delay-sleep-pause-wait/
function sleep(milliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
}


////////////////////////////// Detect IE
// returns version of IE or false, if browser is not Internet Explorer
// https://codepen.io/gapcode/pen/vEJNZN
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = "Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)";

  // IE 11
  // ua = "Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko";

  // Edge 12 (Spartan)
  // ua = "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0";

  // Edge 13
  // ua = "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586";

  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  // other browser
  return false;
}


////////////////////////////// Get the size of the viewport
function getViewportSize() {
  var e = window, a = "inner";
  if(!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }
  return {width: e[a+"Width"], height: e[a + "Height"]};
}


////////////////////////////// Check if any scrollbar exists
// https://tylercipriani.com/blog/2014/07/12/crossbrowser-javascript-scrollbar-detection/
function isScrollbars() {
  // the Modern solution
  if(typeof window.innerWidth === "number")
    return {
      ver: window.innerWidth > document.documentElement.clientWidth,
      hor: window.innerHeight > document.documentElement.clientHeight
    }

  // rootElem for quirksmode
  var rootElem = document.documentElement || document.body;

  // Check overflow style property on body for fauxscrollbars
  var overflowStyle;
    if(typeof rootElem.currentStyle !== "undefined") overflowStyle = rootElem.currentStyle.overflow;
    overflowStyle = overflowStyle || window.getComputedStyle(rootElem, "").overflow;

  function checkOverflowAxis(rootElem, axis)
  {
    axis = axis || "X";

    // check the X or Y axis overflow
    var overflowAxisStyle;
    if(typeof rootElem.currentStyle !== "undefined") overflowAxisStyle = rootElem.currentStyle["overflow" + axis];
    overflowAxisStyle = overflowAxisStyle || window.getComputedStyle(rootElem, "")["overflow" + axis];

    var measurement = axis === "X"? "Width" : "Hei;ght";
    var contentOverflows = rootElem["scroll"+measurement] > rootElem["client"+measurement];
    var overflowShown = /^(visible|auto)$/.test(overflowStyle) || /^(visible|auto)$/.test(overflowAxisStyle);
    var alwaysShowScroll = overflowStyle === "scroll" || overflowAxisStyle === "scroll";
    return (contentOverflows && overflowShown) || (alwaysShowScroll)
  }

  return {
    hor: checkOverflowAxis(rootElem, "X"),
    ver: checkOverflowAxis(rootElem, "Y")
  };
}


////////////////////////////// Getting a scrollbar width
// https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
function getScrollbarWidth () {
  // Creating invisible container
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; // forcing scrollbar to appear
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement("div");
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
    // outer.offsetWidth: 1326
    // inner.offsetWidth: 1310
    // outer.getBoundingClientRect().width: 1326.4000244140625
    // inner.getBoundingClientRect().width: 1309.5999755859375
    // So use getBoundingClicentRect() instead
  // const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
  const scrollbarWidth = Math.round((outer.getBoundingClientRect().width - inner.getBoundingClientRect().width));

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth
}

////////////////////////////// Getting a scrollbar width & Set it to a CSS variable
// https://stackoverflow.com/questions/33606565/is-it-possible-to-calculate-the-viewport-width-vw-without-scrollbar
// Usage
// window.addEventListener('resize', calScrollbarWidth, false); // recalculate on resize
// document.addEventListener('DOMContentLoaded', calScrollbarWidth, false); // recalculate on dom load
// window.addEventListener('load', calScrollbarWidth); // recalculate on load (assets loaded as well)
function calScrollbarWidth() {
  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
}



////////////////////////////// Detecting the final event fired. (ex: when the browser resizing is over)
// For the events need to be handled in between (ex: mousemove), use Debouncing (EJS, p 260)
//
// Usage
// $(window).resize(function(){
//   waitForFinalEvent(function(){
//     initRandom();
//   }, 400 , "Window Resizing"); // Need to longer than threshold in jquery.bookblock.js
// });
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();


////////////////////////////// DOM Element: Create a element
function elt(type, props, ...children){
  let dom = document.createElement(type);
  if(props) Object.assign(dom, props);
  for(let child of children) {
    if(typeof child != "string") dom.appendChild(child);
    else dom.appendChild(document.createTextNode(child));
  }
  return dom;
}


////////////////////////////// DOM element: Create a SVG element
function eltSVG(type, props, ...children){
  let dom = document.createElementNS("http://www.w3.org/2000/svg", type);
  for (var p in props) {
    dom.setAttributeNS(props[p][0], p, props[p][1]);
  }
  for(let child of children) {
    if(typeof child != "string") dom.appendChild(child);
    else dom.appendChild(document.createTextNode(child));
  }
  return dom;
}


////////////////////////////// DOM Element: Remove
function eltRemove (elClass) {
  document.querySelectorAll(elClass).forEach((d) => d.remove());
}


////////////////////////////// Getting Scroll Height - Full VH or Full El's height
function getElScrollHFullPx (sel) {
  let offsetH = document.querySelector(sel).offsetHeight;
  return (window.innerHeight < offsetH) ? window.innerHeight : offsetH;
}
function getElScrollHFullPc (sel, calledBy) {
  let pos = Math.min(getElScrollHFullPx(sel) / window.innerHeight, 1) * 100; // return %
  return pos;
}


////////////////////////////// Getting CSS variable value
// Usage: getCSSVariable('.section.hero-web .container', '--container-baseline-h')
const getCSSVariable = (el, variable) => {
  return getComputedStyle(document.querySelector(el)).getPropertyValue(variable)
}

////////////////////////////// Get CSS variable resolved value
// Usage: getCSSVariableResolvedValue('flex-grow', '.sector.graphic .container', '--hogr-cards-scale')
const getCSSVariableResolvedValue = (property, el, variableName) => {
  // 1. Create a temporary element
  const tempEl = document.createElement('div');
  tempEl.style.setProperty('visibility', 'hidden');
  tempEl.style.setProperty('position', 'absolute'); // Prevents layout shift
  document.body.appendChild(tempEl);

  // 2. Apply the custom property to a standard property that accepts the value type
  tempEl.style.setProperty(variableName,
    getComputedStyle(document.querySelector(el)).getPropertyValue(variableName)); // Get the variable's defined value
  tempEl.style[property] = `var(${variableName})`; // Use the variable in the property

  // 3. Get the computed style of the *standard* property
  const computedValue = window.getComputedStyle(tempEl).getPropertyValue(property);

  // 4. Clean up the temporary element
  document.body.removeChild(tempEl);

  return computedValue; // This will be the evaluated value, e.g., "80px"
}


////////////////////////////// Getting Path's Length
function getPathLength(selector) {
  var els = document.querySelectorAll(selector);
  var len = [];
  els.forEach((el, index) => len.push(el.getTotalLength()));
  return len;
}


////////////////////////////// Getting Path's Length: Formatting
// Usage: getPathLengthFormat('.head-line-path-org', '--head-line', true);
// Usage: getPathLengthFormat('.brain-line-path', '--brain-line', false);
function getPathLengthFormat(path, name, isReverse=false) {
  let headLineLengthsOrg = getPathLength(path);

  if(isReverse) headLineLengthsOrg.reverse();
  let headLineLengthsCeil = [];
  let headLineLengthsStrOrg = '';
  let headLineLengthsStrCeil = '';
  headLineLengthsOrg.forEach((length, i) => {
    headLineLengthsStrOrg += `${name}${i+1}: ${length}; ${((i+1)%5 === 0) ? '\n' : ''}`
    headLineLengthsCeil.push(Math.ceil(length));
    headLineLengthsStrCeil += `${name}${i+1}: ${Math.ceil(length)}; ${((i+1)%5 === 0) ? '\n' : ''}`
  });
  
  console.log(headLineLengthsOrg.join(', '));
  console.log(headLineLengthsStrOrg);
  console.log(headLineLengthsCeil.join(', '));
  console.log(headLineLengthsStrCeil);
}


////////////////////////////// Circular Motion Path
function setCircularAttr (i, deg, radius, type='to', isSVG=true) {
  if(isSVG) {      
    let angle = i * deg + ((type==='from')? 0 : 360);
    return {transform: `rotate(${angle}) translate(${radius},0) rotate(-${angle})`}
  }
  else {
    return `M ${-radius}, 0
            a ${radius},${radius} 0 1,0 ${radius * 2},0
            a ${radius},${radius} 0 1,0 -${radius * 2},0z`
  }
}


////////////////////////////// Timeline Control
function tlControl (tls=[], mode="play", pos=0, gsapRef=null, playToDur=1, playToCb=()=>{}, playToCbParams=[]) {
  if(!tls) return;
  if(!Array.isArray(tls)) tls = [tls];
  if(tls.length < 1) return;

  function tlsRevert (tls, isPop=false) {
    for(let i = tls.length-1; i >= 0; !isPop ? i-- : i = tls.length-1) {
      tls[i].revert();
      tls[i] = null;
      if(isPop) tls.pop()
    }
  }

  switch(mode) {
    case null:
    case undefined:
      break;
    case "play":
      tls.forEach(tl => tl && tl.resume());
      break;
    case "pause":
      tls.forEach(tl => tl && tl.pause())
      break;
    case "seek":
      tls.forEach(tl => tl && tl.seek(pos))
      break;
    case "playTo":
      !!gsapRef && tls.forEach(tl => tl && gsapRef.to(tl, {duration: playToDur, time: pos, onComplete: playToCb, onCompleteParams: playToCbParams}))
      break;
    case "init":
      tlsRevert(tls);
      break;
    case "remove":
      tlsRevert(tls, true);
      break;
    default:
      break;
  }
}


////////////////////////////// Timeline Control: Play or Pause
function tlPlayPause(tls=[], tlsName, msg='', logOn=false) {
  if(!tls) return;
  if(!Array.isArray(tls)) tls = [tls];
  if(tls.length < 1) return;

  if(!tls || tls.length < 1 || !!tls[0] === false) {
    csLog(`${tlsName}, Can't play or pause --> tls: ${tls}, tls.length: ${tls.length}, tls[0]: ${tls[0]}`);
  } else {
    tlControl(tls, tls[0].paused() ? "play" : "pause");    
    if(msg.length > 0 || logOn) csLog(msg + (logOn ? `${tlsName}, isPaused: ${tls[0].paused()}` : ''));
  }
}


////////////////////////////// Get page from the location
function getPagefromLocation (pathname, isError){
  return (isError) ? 'error' : ((pathname.substring(1) === "") ?  'home' : pathname.substring(1));
}




////////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  csLog,
  randomSign,
  random,
  randomInt,
  randomIntIncMax,
  round,
  roundFn,
  round10,
  decimalPlace,
  sleep,
  detectIE,
  getViewportSize,
  isScrollbars,
  getScrollbarWidth,
  calScrollbarWidth,
  waitForFinalEvent,
  elt,
  eltSVG,
  eltRemove,
  getElScrollHFullPx,
  getElScrollHFullPc,
  getCSSVariable,
  getCSSVariableResolvedValue,
  getPathLength,
  getPathLengthFormat,
  setCircularAttr,
  tlControl,
  tlPlayPause,
  getPagefromLocation
}